// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"AreaChart_skeletonWrapper__stePA","heading":"AreaChart_heading__Zti2W","chartWrapper":"AreaChart_chartWrapper__y7PMj"};